import { Component, effect, inject, signal } from '@angular/core';
import { Subscription, tap } from 'rxjs';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-blocks-quota',
  templateUrl: 'blocks-quota.component.html',
  styleUrls: ['./blocks-quota.component.scss']
})
export class BlocksQuotaComponent {
  activeBlock$ = inject(SurveyEditorService).surveyEditor$().blocks.active$;
  numberOfBlocksOptions$ = signal<number[]>([]);
  showAdvanceSettings$ = signal<boolean>(false);

  private subscription: Subscription;

  constructor() {
    effect(
      (onCleanup: Function) => {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }

        const blocks = this.activeBlock$().get('groupedBlockIds').value;
        this.setNumberOfBlocks(blocks);

        this.subscription = this.activeBlock$()
          .get('groupedBlockIds')
          .valueChanges.pipe(
            tap((newBlocks) => {
              const currentQuantity = this.activeBlock$().get('evenDistributionQuantity').value;
              if (currentQuantity > 0 && newBlocks.length < currentQuantity) {
                this.activeBlock$().get('evenDistributionQuantity').setValue(newBlocks.length);
              }
              this.setNumberOfBlocks(newBlocks);
            })
          )
          .subscribe();

        onCleanup(() => {
          this.subscription.unsubscribe();
        });
      },
      { allowSignalWrites: true }
    );
  }

  onShowAdvanceSettings(): void {
    this.showAdvanceSettings$.update((s) => !s);
  }

  private setNumberOfBlocks(blocks: string[]): void {
    this.numberOfBlocksOptions$.set(Array.from({ length: blocks.length }, (_, i) => i + 1));
  }
}
